interface AppErrorProps {
  variant?: "runtime" | "chunk";
}

const MESSAGES: Record<NonNullable<AppErrorProps["variant"]>, string> = {
  runtime: "일시적인 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.",
  chunk: "새 버전이 배포되었어요.\n새로고침 후 다시 이용해 주세요.",
};

const AppError = ({ variant = "runtime" }: AppErrorProps) => {
  const handleReload = () => window.location.reload();
  const handleGoHome = () => window.location.replace("/");

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <i className="ii ii-warning-circle-outline text-[34px] text-primary" />
      <p className="text-lg font-semibold mt-5 mb-8 whitespace-pre-line">{MESSAGES[variant]}</p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={handleReload}
          className="px-5 py-2.5 rounded-lg bg-primary-500 text-white font-medium"
        >
          새로고침
        </button>
        <button
          type="button"
          onClick={handleGoHome}
          className="px-5 py-2.5 rounded-lg border border-solid border-gray-300 font-medium"
        >
          홈으로
        </button>
      </div>
    </div>
  );
};

export default AppError;
